export default __webpack_public_path__ + "static/media/mTop_2_c2.c03623a7.jpeg";